// Get user info from localStorage (with 1-day expiry logic

  import Cookies from 'js-cookie';
import api from '../services/api';
// Get user info from localStorage with expiry check
export const getUserInfo = () => {
  const data = localStorage.getItem('userInfo');
  if (!data) return null;

  const parsed = JSON.parse(data);
  if (Date.now() > parsed.expiry) {
    localStorage.removeItem('userInfo');
    return null;
  }
  return parsed;
};

// Clear authentication data
export const logout = () => {
  Cookies.remove('Auth_Token');
  delete api.defaults.headers.common['Authorization'];
  sessionStorage.removeItem('jwt_token');
  localStorage.removeItem('userInfo');
};

// Check authentication status
export const isAuthenticated = () => {
  const token = Cookies.get('Auth_Token');
  if (!token) return false;

  const userInfo = getUserInfo();
  if (!userInfo) {
    logout();
    return false;
  }
  return true;
};

// Check if user is admin
export const isAdmin = () => {
  const userInfo = getUserInfo();
  return userInfo?.user?.role === 'Admin';
};

// Get current user data
export const getCurrentUser = () => {
  const userInfo = getUserInfo();
  return userInfo?.user || null;
};